import { noop } from 'lodash';

import { FlagClient } from './flag-context';

export const emptyClient: Readonly<FlagClient> = {
  identify: noop,
  on: noop,
  off: noop,
  waitUntilReady: async () => {
    console.warn(`Obtained empty client waitUntilReady promise`);
  },
};
